angular.module('mtic.components.modules.c3').
directive('c3RunLikeMathModuleSelect', function (
  $log,
  $timeout,
  TIMING_CONSTANTS,
  EventManager,
  C3_META_ASSET_URL,
  PIXI,
  language,
  MODULE_AVAILABLE_LANGUAGE,
  MapStateService,
  userAccount,
  preliveCheck,
  DEV_VARIABLES,
  C3_ASSET_URL,
  TeacherDataService,
  PlatformService
) {

  return {
    templateUrl: 'template.html',//<canvas id="canvas" width="300" height="300"></canvas>',
    scope: {
      moduleMapData: "=moduleMapData",
      interceptClick: "=?"

    },
    link: function (scope) {
      scope.badBrowser = false;
      /*
      if(window.isWebEmbedConnect && !scope.interceptClick){
        //kickout to browser
        var userData = userAccount.getData();
        var cur_class = userAccount.getData().role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();
        window.location.href = window.location.href.replace('/?debugBrowsers#/web-embed-connect', '').replace('web-embed-response', '').replace('&iam-logout', '')+'?web-open-browser&firebase_token='+userData.firebase_token+'&uuid='+userData.uuid+'&session_key='+userData.sessionKey+'&user_id='+userData.user_id+'&class_id='+cur_class;
      }else */
      if(window.isWebEmbedConnect && !scope.interceptClick){
        //scope.badBrowser = true;
      }
      var eventManager = new EventManager('c3RunLikeMathModuleSelect', scope);
      var planetContainer,startx=620,starty=250,planetInfos = [
        {slug:"run_like_math_addition",name:"Addition"},
        {slug:"run_like_math_subtraction",name:"Subtraction"},
        {slug:"run_like_math_multiplication",name:"Multiplication"},
        {slug:"run_like_math_division",name:"Division"}
      ];
      var positions = [
        {x:0+startx,y:275+starty,width:200,height:200},
        {x:200+startx,y:100+starty,width:100,height:100},
        {x:0+startx,y:25+starty,width:100,height:100},
        {x:-200+startx,y:100+starty,width:100,height:100}
      ];
      var canvas_el,focusedIndex=0,planetSprites;
      var canvasDimension;var sBackground;var sBlackScreen;var sShip;var sStars;var container;var Planets=[];var app;        scope.currentActiveSubModule = null;

      scope.goBackToClasses = function(){
        eventManager.broadcast("navbar:my-classes:click");
        eventManager.broadcast('module:close:resource');
      }

      scope.hasModuleOption = function(){
        return true && scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      }

      scope.$watch('moduleMapData', function(moduleMapData){
        // if (!moduleMapData || EXISTS) {
        //   return;
        // }
        $timeout(()=>{
          Initialize()
          setSubmodule(MapStateService.getActiveModule());
          EXISTS = true;
        },100)
      });

      eventManager.listen('module:change:submodule', function(e, slug) {
        if(MODULE_AVAILABLE_LANGUAGE[slug]){
              language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[slug])
        }
      });

      eventManager.listen('module:change:meta', function(e, slug) {
        language.resetAvilableOptions();
        if(MODULE_AVAILABLE_LANGUAGE[slug]){
              language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[slug])
        }
        if (MapStateService.getActiveModule() === 'run_like_math')
        {
          MapStateService.setActiveModule(scope.moduleMapData.slug);
          eventManager.broadcast('module:close:resource', {isPassive:true});
        }
      });

      var lastSlug;
      var setSubmodule = function(slug){
        var i;
        for (i = 0; i < scope.moduleMapData.resources.length; i ++){
          if (slug === scope.moduleMapData.resources[i].slug){
            scope.interceptClick = {
              slug:slug
            };
            eventManager.broadcast("submodule:change:in:run_like_math",scope.moduleMapData.resources[i]);
          }
        }

        return;
      }

      var populatePlanetContainer = function(focusIndex,initialCall){
        Planets = [];
        var indexCount = 0;
        for(var i=focusIndex;i<focusIndex+4;i++){
          var actualIndex = i % 4;
          var planet = new Planet(planetSprites[actualIndex], positions[indexCount].x,positions[indexCount].y,positions[indexCount].width, positions[indexCount].height,planetInfos[actualIndex].slug,planetInfos[actualIndex].name,initialCall);
          Planets.push(planet);
          indexCount++;
        }
      }

      var createOpenButton = function(){
        var openButton = new PIXI.Sprite.fromImage(C3_ASSET_URL + 'playbutton.png');
        openButton.buttonMode = true;
        openButton.interactive = true;
        openButton.width = 336;
        openButton.height = 115;
        openButton.position.set(positions[0].x-165,positions[0].y+50);
        openButton.on('pointertap', function(e){
          var cur_slug = Planets[0].sprite.slug;
          $timeout(function() {
            setSubmodule(cur_slug);
          }, TIMING_CONSTANTS.INSTANT);
        });

        var graphics = new PIXI.Graphics();
        var setupText = function(){
          openButton.removeChild(graphics);
          graphics.removeChildren();
          graphics.clear();
          graphics =  new PIXI.Graphics();
          var textInfo = new PIXI.Text(language.get("16290"));
          textInfo.style.align = "center";
          textInfo.style.fill = "white";
          textInfo.style.fontFamily = "vanilla-extract-edit";
          textInfo.style.fontSize = 70;
          graphics.addChild(textInfo);
          textInfo.x += 20;
          textInfo.y = openButton.height/2 - textInfo.height/2 - 10;
          graphics.position.set(20,0);
          openButton.addChild(graphics);
        }
        setupText();
        container.addChild(openButton);

        eventManager.listen('language:change', function() {
          setupText();
        });
      }

      var setupLeftAndRightArrows = function(){
        var rightArrow = new PIXI.Sprite.fromImage(C3_ASSET_URL + 'arrow.png');
        rightArrow.interactive = true;
        rightArrow.buttonMode = true;
        rightArrow.y = 350 ;
        rightArrow.x = 350+ positions[0].width + 235;
        rightArrow.on('pointertap', function(e){
          focusedIndex+=1;
          reDrawPlanetContainer(focusedIndex);
        });
        container.addChild(rightArrow);

        var leftArrow = new PIXI.Sprite.fromImage(C3_ASSET_URL + 'left_arrow.png');
        leftArrow.interactive = true;
        leftArrow.buttonMode = true;
        leftArrow.y = 350;
        leftArrow.x = 350 ;
        leftArrow.on('pointertap', function(e){
          focusedIndex-=1;
          if(focusedIndex<0){
            focusedIndex = 3;
          }
          reDrawPlanetContainer(focusedIndex);
        });
        container.addChild(leftArrow);
      }

      var setupHeadingText = function(){
        var graphics = new PIXI.Graphics();
        var textInfo = new PIXI.Text("MathleTIC");
        textInfo.style.align = "center";
        textInfo.style.fill = "white";
        textInfo.style.fontFamily = "vanilla-extract-edit";
        textInfo.style.fontSize = 65;
        graphics.addChild(textInfo);
        graphics.position.set(positions[2].x - (textInfo.width/2),20);//((openButton.width-textInfo.width)/2,openButton.height/2);
        container.addChild(graphics);
      }

      var Initialize = function()
      {
        PIXI.ticker.shared.add(delta_resize);
        canvas_el = document.getElementById('c3-run-like-math-map-canvas');
        var width = canvas_el.parentElement.clientWidth;
        var height = canvas_el.parentElement.clientHeight;
        canvasDimension = {
          width: width,
          height: height
        }
        // Create the application and container
        app = PIXI.autoDetectRenderer(canvasDimension.width, canvasDimension.height, {
          autoResize: true,
          backgroundColor: 0x18052b,
          view: canvas_el
        });
        // Load Assets
        container = new PIXI.Container();
        container.alpha = 0.01
        setupHeadingText();
        createOpenButton();
        //add left right arrows
        setupLeftAndRightArrows();
        planetContainer = new PIXI.Container();
        Planets = [];
        planetSprites = [];
        for(var i=0;i<4;i++)
        {
          var planetSprite = new PIXI.Sprite.fromImage(C3_ASSET_URL + 'moon.png');
          planetSprites.push(planetSprite);
        }

        populatePlanetContainer(0,true);
        container.addChild(planetContainer);
        // if(TeacherDataService.isTeacherWorkspaceView){
        //   container.scale.set(1,0.9);
        // }
        container.y += 100;
        //if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1200){
          //container.x -= 100;
          //container.y += 50;
          //container.scale.set(0.6,0.6)
        //}
        //else if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1400){
        //   //container.y += 50;
        //   container.scale.set(0.8,0.8)
        // }
        window.addEventListener("resize", onResize);
        $timeout(function(){
          onResize();
          container.alpha = 1
        }, 200)
      }

      var removeAllChild = function(pContainer){
        while(pContainer.children[0]){
          while(pContainer.children[0].children[0]){
            pContainer.children[0].removeChild(pContainer.children[0].children[0]);
          }
          pContainer.removeChild(pContainer.children[0]);
        }
      }

      var reDrawPlanetContainer = function(focusIndex){
        removeAllChild(planetContainer)
        populatePlanetContainer(focusIndex);
        container.addChild(planetContainer);
      }

      var updateSpriteAnimation = function(){
        angular.forEach(Planets,function(each){
          var diffX = each.sprite.moveToX - each.sprite.x;
          var diffY = each.sprite.moveToY - each.sprite.y;
          if(diffX!==0){
            each.sprite.x += each.diffX/10;
          }

          if(diffY!==0){
            each.sprite.y += each.diffY/10;
          }

        });
      }

        // Update Function
      function delta_resize(delta)
      {
        updateSpriteAnimation();
        app.render(container);
      }

      eventManager.listen('module:change:meta', function(data){
        scope.currentActiveSubModule = null;
      });

        // Define Planet Object
      var Planet = function(sprite, xPos, yPos, width, height, slug,title,initialCall)
      {
        this.xPos = xPos;
        this.yPos = yPos;
        // Sprite
        this.sprite = sprite;
        this.sprite.width= width;
        this.sprite.height = height;
        if(initialCall){
          this.sprite.x = this.xPos;
          this.sprite.y = this.yPos;
        }
        this.sprite.moveToX= this.xPos;
        this.sprite.moveToY= this.yPos;
        this.diffX =  this.sprite.moveToX - this.sprite.x;
        this.diffY =  this.sprite.moveToY - this.sprite.y;
        sprite.anchor.set(0.5, 1);
        this.sprite.slug = slug;
        var graphics = new PIXI.Graphics();

        var setupText = () => {

          // Text Information
          this.sprite.removeChild(graphics);
          graphics.removeChildren();
          graphics.clear();
          var textInfo = new PIXI.Text(language.get(slug));
          textInfo.style.align = "center";
          textInfo.style.fill = "white";
          textInfo.style.fontFamily = "vanilla-extract-edit";
          textInfo.style.fontSize = 150;
          graphics.position.set(-(textInfo.width/2),-985);
          graphics.addChild(textInfo);
          this.sprite.addChild(graphics);
        }

        setupText();
        eventManager.listen('language:change', function() {
          setupText();
        });
        // this.sprite.addChild(graphics);
        // Add everything to the stage
        planetContainer.addChild(this.sprite);
      }

      this.destroy = function() {
        eventManager.broadcast('destroy-c3-run-like-math-map')
        if(planetContainer)
        {
          planetContainer.removeChildren();
        }
        container.removeChildren();
        app.destroy();
        PIXI.ticker.shared.remove(delta_resize);
        EXISTS = false;

        window.removeEventListener("resize", onResize);
      }.bind(this)

      scope.$on('$destroy', function() {
        this.destroy();
      }.bind(this));

      eventManager.listen('module:change:meta', function(e, slug) {
        eventManager.broadcast("close:current:module",slug);
      });

      scope.returnToMetaModules = function() {
        eventManager.broadcast('module:change:meta', {});
      }

      function onResize(sidepanel_expanded){
        if (!canvas_el) {
          return;
        }

        var sidepanel_width = 0;
        if(sidepanel_expanded === true || sidepanel_expanded === false){
          sidepanel_width = sidepanel_expanded ? 140:-200;
        }

        var canvasDimention = {
          width: canvas_el.parentElement.clientWidth - sidepanel_width,
          height: canvas_el.parentElement.clientHeight
        }

        canvas_el.width = canvasDimention.width;
        canvas_el.height = canvasDimention.height;


        app.resize(canvasDimention.width, canvasDimention.height);
        $log.log('from resize : ' , planetContainer.width, container.width, app.width, canvas_el.parentElement.clientWidth)
        if(container && app){
          var scale = Math.min(0.8, app.width/800)
          container.scale.set(scale, scale);
          container.x = app.width / 2  - container.width - 80;
          container.y = app.height / 2 - container.height/2;
        }
      }
      eventManager.listen('sidepanel:toggled', function(e, val){
        if(!PlatformService.isPhonePortrait()){
          onResize(val);
        }
      })

      scope.getLang = language.get;
    }
  }
});

var PIXI_Load_Cache;
var EXISTS;
